import React, { FunctionComponent, useCallback, useContext } from 'react';
import { ElementConfigType } from '../store/type';
import { MyComponentType } from '@/pages2/DetailedDescription/component-factory/component-types';
import { toJS } from 'mobx';
import { ComponentIdEnum } from '@/pages2/DetailedDescription/component-factory/ComponentIdEnum';
import { lazy } from 'ice';
import { ConfigHOC, DropContainer } from '../HOC';
import { useBasicDrop } from '../utils/useBasicDrop';
import { PageEditorStoreContext } from '../store/PageEditorStore';

type Props = ElementConfigType & { ComponentBasicRender: FunctionComponent<any> };

const MultiRowContainer = (props: Props) => {
  const { elements, privateSchema, id, ComponentBasicRender } = props;
  const { length } = elements;

  return (
    <div id={id} className="h-full flex w-full flex-col">
      {elements.map((item, index) => (
        <ComponentBasicRender
          {...toJS(item)}
          styles={index !== length - 1 ? { marginBottom: privateSchema?.marginBottom } : {}}
          key={item.nodeId}
        />
      ))}
    </div>
  );
};

export const MultiRowContainerHOC: MyComponentType<Props> = (props: any) => {
  const pageEditorStore = useContext(PageEditorStoreContext);
  return (
    <>
      {pageEditorStore.isRenderHtml ? (
        <MultiRowContainer {...props} />
      ) : (
        <DropContainer {...props}>
          <MultiRowContainer {...props} />
        </DropContainer>
      )}
    </>
  );
};

const ConfigForm = lazy(() => import('../components-with-definition/MultiRowContainerComponentDefinition'));

MultiRowContainerHOC.definition = {
  id: ComponentIdEnum.ROWS_CONTAINER_COMPONENT,
  name: '多行容器',
  icon: 'https://cdn.resource.youniverse.cc/d2c-app-dev/oZeo1jtD5TONnoGVDx5Ju.png?image_process=resize,w_200',
  position: 889, // 显示顺序
  isContainer: true,
  config: {},
  privateSchema: {
    subContainersNumber: 2,
    marginBottom: 2,
  }, // 组件自己的属性 不能通用的部分
  category: 'container',
  configForm: ConfigHOC(ConfigForm),
};
